module.exports = __webpack_public_path__ + "img/1.354fa6f3.jpg";